var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navbar-item"},[(_vm.external)?_c('a',{attrs:{"href":_vm.path}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_c('router-link',{attrs:{"exact":"","to":_vm.path}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-048583e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/navbar/navbar-item.vue
// module id = null
// module chunks = 